import { EntityRepository } from '@record-it-npm/synchro-client';
import { useCallback } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { useGlobalConfirmDeleteDialog } from 'record-it-components/hooks/useGlobalConfirmDeleteDialog';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityRepository } from '../useEntityRepository';

export function useEntityDeleteHandlerFactory<TEntityName extends EntityName>(
  opts: UseEntityDeleteHandlerFactoryOptions<TEntityName>
): (
  entity: AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']
) => () => void {
  const getName = useEventCallback(opts.getName);
  const globalConfirmDeleteDialogHandle = useGlobalConfirmDeleteDialog();

  const repository = useEntityRepository(opts.entityName) as EntityRepository<
    any,
    any,
    any
  >; // for performance reasons

  const handleDelete = useEventCallback((entity: any) => {
    repository.delete(entity);
  });

  return useCallback(
    (entity) => {
      return () => {
        globalConfirmDeleteDialogHandle.open({
          item: entity,
          getName,
          onDelete: handleDelete
        });
      };
    },
    [getName, globalConfirmDeleteDialogHandle, handleDelete]
  );
}

export type UseEntityDeleteHandlerFactoryOptions<
  TEntityName extends EntityName
> = {
  entityName: TEntityName;
  getName: (
    entity: AppEntityManagerEntityTypesByEntityName[TEntityName]['entity']
  ) => string;
};
